// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

ElementUI.Dialog.props.lockScroll.default = false;


//引入mint-UI
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// //引入 vue-iconfont
// import './assets/iconfont.js'; // Symbol 代码
// import 'vue-iconfont/style/icon.css'; // 样式文件
// import vueIconfont from 'vue-iconfont'; // icon 组件

// 引入全局可用阿里图标样式文件
import '@/assets/font/iconfont/iconfont.css'
// 引入全局可用阿里图标js文件
import '@/assets/font/iconfont/iconfont.js'
// 引入自己设置的全局icon基础样式，一般用于规定基础的svg宽高和图标大小
// import '@/assets/font/iconfont/iconfont.css'


// // 设置动态计算rem默认fontsize
import "@/common/js/flexible";


// 判断电脑注册表是否有该客户端的方法 https://github.com/ismailhabib/custom-protocol-detection
import "@/common/js/protocolcheck";

//引入阿里图矢
// import '@/assets/font/iconfont/iconfont.css'

//引入一些路由的判断
import '@/router/routerCheck';

// 设置网页标题
import "@/common/js/webTitle";

// v-viewer 是一个基于 Vue.js 的图片查看器组件
import 'viewerjs/dist/viewer.css' // 引入viewerjs的CSS
import Viewer from 'v-viewer'

//引入Url参数加密
// import UrlEncode from '@/common/js/UrlEncode'
// Vue.prototype.$UrlEncode = UrlEncode

//使用v-viewer
Vue.use(Viewer)

// Viewer.setDefaults({
//   Options: { 
//   'zIndex': 9999,
//   'inline': true, //启用lnline模式
//   'button': true, //显示右上角关闭按钮
//   'navbar': true, //显示缩略图导航
//   'title': true, //显示当前图片的标题
//   'toolbar': true, //显示工具栏
//   'tooltip': true, //显示缩放百分比
//   'movable': true, //显示可移动
//   'zoomable': true, //图片是否可缩放
//   'rotatable': true, //图片是否可旋转
//   'scalable': true, //图片是否可翻转
//   'transition': true, //使用css3过度
//   'fullscreen': true, //播放时是否全屏
//   'keyboard': true, //是否支持键盘
//   'url': 'data-source' //设置大图片的url
//   }
// })

//全局取消body滚动锁定。
// ElementUI.Dialog.props.lockScroll.default = false;
//使用ElementUI
Vue.use(ElementUI);

//使用mint-UI
Vue.use(MintUI)

//vue 在启动时是否生成生产提示
Vue.config.productionTip = false

// 创建事件总线对象
Vue.prototype.$bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js